{
  "pages_records.kind.task": "Task",
  "pages_records.kind.project": "Project",
  "pages_records.kind.plan": "Plan",
  "pages_records.kind.routine": "Routine",
  "pages_records.kind.period": "Period",
  "pages_records.kind.span": "Period",
  "pages_records.kind.note": "Note",
  "pages_records.kind.life_area": "Life area",
  "pages_records.kind.life_schema": "Life table",
  "pages_records.kind.life_item": "Life record",
  "pages_records.kind.goal": "Goal",
  "pages_records.kind.decision": "Decision",
  "pages_records.kind.moment": "Journal entry",
  "pages_records.kind.knowledge_item": "Knowledge",
  "pages_records.kind.saved_view": "Saved view",
  "pages_records.property.schedule_date": "Date",
  "pages_records.property.priority": "Priority",
  "pages_records.property.estimate_minutes": "Estimate",
  "pages_records.property.description": "Description",
  "pages_records.property.content": "Content",
  "pages_records.property.start_date": "Start",
  "pages_records.property.end_date": "End",
  "pages_records.property.target_date": "Target date",
  "pages_records.property.frequency": "Repeats",
  "pages_records.property.frequency_count": "How many",
  "pages_records.property.section": "Section",
  "pages_records.priority.low": "Low",
  "pages_records.priority.normal": "Normal",
  "pages_records.priority.high": "High",
  "pages_records.frequency.daily": "Every day",
  "pages_records.frequency.times_per_week": "Times a week",
  "pages_records.frequency.every_x_days": "Every few days",
  "pages_records.section.tracking": "Tracking",
  "pages_records.section.guide": "Guide",
  "pages_records.placeholder.task": "Task name",
  "pages_records.placeholder.project": "Project name",
  "pages_records.placeholder.plan": "Plan name",
  "pages_records.placeholder.routine": "Routine name",
  "pages_records.placeholder.period": "Period name",
  "pages_records.placeholder.span": "Period name",
  "pages_records.placeholder.note": "Note title",
  "pages_records.placeholder.life_area": "Life area name",
  "pages_records.placeholder.life_schema": "Table name",
  "pages_records.placeholder.default": "Record name",
  "pages_records.placeholder.text": "Type…",
  "pages_records.add_property": "Add a property",
  "pages_records.edit_property": "Edit {{property}}",
  "pages_records.clear_property": "Clear",
  "pages_records.no_properties": "Nothing left to add",
  "pages_records.empty_value": "Empty",
  "pages_records.title_label": "Title",
  "pages_records.complete_task": "Complete this task",
  "pages_records.reopen_task": "Reopen this task",
  "pages_records.open_record": "Open this record",
  "pages_records.in_trash": "in trash",
  "pages_records.unavailable": "record unavailable",
  "pages_records.untitled": "Untitled",
  "pages_records.saving": "Saving…",
  "pages_records.save_error": "That could not be saved.",
  "pages_records.load_error": "That could not be loaded.",
  "pages_records.loading": "Loading…",
  "pages_records.cancel": "Cancel",
  "pages_records.create": "Create",
  "pages_records.status.pending": "Pending",
  "pages_records.status.open": "Open",
  "pages_records.status.active": "Active",
  "pages_records.status.completed": "Done",
  "pages_records.status.cancelled": "Cancelled",
  "pages_records.status.canceled": "Cancelled",
  "pages_records.status.skipped": "Skipped",
  "pages_records.status.trashed": "In trash",
  "pages_records.status.archived": "Archived",
  "pages_records.status.draft": "Draft",
  "pages_records.status.paused": "Paused",
  "pages_records.composer.title": "Add a record",
  "pages_records.composer.search": "Search records, or type a new name",
  "pages_records.composer.search_label": "Search records",
  "pages_records.composer.type": "Record type",
  "pages_records.composer.results": "Results",
  "pages_records.composer.create_named": "Create new: “{{title}}”",
  "pages_records.composer.create_blank": "Create a new {{kind}}",
  "pages_records.composer.no_results": "No matching records",
  "pages_records.composer.create_unavailable": "This type cannot be created here.",
  "pages_records.composer.back": "Back to search",
  "pages_records.composer.insert": "Create and insert",
  "pages_records.composer.context_parent": "Added under this task.",
  "pages_records.composer.context_plan": "Attached to this plan.",
  "pages_records.composer.context_project": "Attached to this project.",
  "pages_records.composer.context_table": "Added to this table.",
  "pages_records.composer.area": "Area",
  "pages_records.composer.select_area": "Select an area",
  "pages_records.composer.table": "Table",
  "pages_records.composer.select_table": "Select a table",
  "pages_records.composer.schema_kind": "Table type",
  "pages_records.composer.schema_kind.record": "Record log",
  "pages_records.composer.schema_kind.entity": "Thing",
  "pages_records.composer.schema_kind.guide_entry": "Guide entry",
  "pages_records.composer.time_mode": "Time",
  "pages_records.composer.time_mode.none": "No time",
  "pages_records.composer.time_mode.date": "A day",
  "pages_records.composer.time_mode.instant": "A moment",
  "pages_records.composer.time_mode.interval": "A span",
  "pages_records.composer.fields": "Fields",
  "pages_records.composer.device_timezone": "Device timezone: {{zone}}",
  "pages_records.composer.name": "Name",
  "pages_records.composer.date": "Date",
  "pages_records.composer.start": "Start",
  "pages_records.composer.end": "End",
  "pages_records.tool.tasks": "Tasks",
  "pages_records.tool.calendar": "Calendar",
  "pages_records.tool.saved_view": "Saved view",
  "pages_records.tool.focus": "Focus",
  "pages_records.tool.attachment": "File",
  "pages_records.tool.count": "{{value}} rows",
  "pages_records.tool.empty_tasks": "No tasks here yet.",
  "pages_records.tool.empty_view": "Nothing in this view yet.",
  "pages_records.tool.empty_table": "No rows yet.",
  "pages_records.tool.new_task": "New task",
  "pages_records.tool.new_row": "New row",
  "pages_records.tool.more": "Show more",
  "pages_records.tool.attaches_plan": "Goes into the plan “{{name}}”",
  "pages_records.tool.attaches_project": "Goes into this project",
  "pages_records.tool.attaches_standalone": "Created without a plan or project",
  "pages_records.tool.configure_life": "Choose a life table for this block.",
  "pages_records.tool.live": "Live view",
  "pages_records.tool.download": "Download",
  "pages_records.tool.media_unavailable": "This file cannot be shown.",
  "pages_records.tool.view_date": "Date",
  "pages_records.tool.view_mode": "View",
  "pages_records.tool.calendar.day": "Day",
  "pages_records.tool.calendar.week": "Week",
  "pages_records.tool.calendar.month": "Month",
  "pages_records.tool.calendar.year": "Year",
  "pages_records.tool.add": "Add",
  "pages_records.tool.retry": "Try again"
}
